import React, { useEffect, useRef, useState } from 'react'
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, Menu, MenuItem, Snackbar } from "@mui/material";
import { Alert, Button, FormControl, FormControlLabel, IconButton, InputBase, InputLabel, Radio, Stack, Select, TextField } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';
import { api } from '../../redux/api';
import { useSelector, useDispatch } from 'react-redux';
import CommonGrid from './CommonGrid';
import {
  ActiveMQ,
  AmazonSQS,
  As2,
  Azure,
  BridgeGateWebService,
  BridgeGateFTP,
  BridgeGateSocket,
  Cmd,
  Database,
  Email,
  File,
  FTP,
  Http,
  JMS,
  Kafka,
  MqSeries,
  Msmq,
  Socket,
  Ssh,
  WebService
} from './ConnectionTypes/index';
import { Loader } from '../../utils/loader';
import { treeActions } from '../../redux/slices/treeSlice';
import DataStream from './ConnectionTypes/DataStream';
import ErrorModal from '../ItemProperties/Forms/FieldDataValidation/ErrorModal';
import { decryption, encryption } from '../../utils/utilFunctions';
import { cloneDeep, debounce } from 'lodash';
import { Box } from '@mui/system';
import LightTooltip from '../../commonComponents/LightTooltip';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import { OUT_TYPES } from '../../constants/constantList';
import SendDataControls from '../ItemProperties/WorkflowProperties/GetData/SendDataControls/SendDataControls';
import GraphQL from './ConnectionTypes/GraphQL';
import GoogleCloudStorage from './ConnectionTypes/GoogleCloudStorage';

const ConnectionScreen = ({ direction, currTab, handleClose, pdcConnectionName, screen, origin = "", onPdcSelect, source }) => {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });
  const { account } = useSelector((state) => state.queryParams);
  const { leftTree } = useSelector((state) => state.treeData[state.treeData.currentScreen]);
  const leftSelectedNode = leftTree?.tree?.body?.selectedNode;
  const pdcConnection = useSelector((state) => state?.treeData?.inbound?.pdcConnection);
  const pdcConnectionList = useSelector((state) => state?.treeData?.inbound?.pdcConnectionList);
  const [types, setTypes] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [filtertedRows, setFilteredRows] = useState([]);
  const [connectionName, setConnectionName] = useState('');
  const [connectionType, setConnectionType] = useState('');
  const [connectionDetails, setConnectionDetails] = useState();
  const [pdcSelected, setPdcSelected] = useState(true);
  const [filterBy, setFilterBy] = useState('name');
  const [filterByConnectionType, setFilterByConnectionType] = useState('');
  const [content, setContent] = useState(null);
  const [test, setTest] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [searchItem, setSearchItem] = useState('');
  const [pdcDetails, setPdcDetails] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [filteredValueData, setFilteredValueData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(false);
  const [doNotCall, setDoNotCall] = useState(true);
  const [searchBtn, setSearchBtn] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [throttleTimeout, setThrottleTimeout] = useState(null);
  const [oldPdc, setOldPdc] = useState('');
  const [currentNode, setCurrentNode] = useState(null);
  const [showAddIcon, setShowAddIcon] = useState(true);
  const [applyChanges, setApplyChanges] = useState(false);
  const [savedChanges, setSavedChanges] = useState(false);
  const [newConnectionDetails, setNewConnectionDetails] = useState(null);
  const [checkNode, setCheckNode] = useState(null);
  const [addNew, setAddNew] = useState(true);
  const [inConnections, setInConnections] = useState([]);
  const [outConnections, setOutConnections] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [disableSelect, setDisableSelect] = useState(true);
  const transferRef = useRef(null);
  const oldConnectionDetails = useRef(null);
  const inRef = useRef(null);
  const outRef = useRef(null);

  const gridApiRef = useRef(null)
  const ref = useRef(null);

  const handleDelete = (value, data) => {
    setConfirmModal(true);
    setApplyChanges(false);
    setSavedChanges(false);
    setDoNotCall(false);
    setConnectionName(value);
  }
  const handleSearchOptionClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  }
  const handleMenuItemClick = (value) => {
    setFilterBy(value);
    handleMenuClose();
  }
  const deleteHandler = () => {
    const list = [...new Set(pdcConnectionList.flatMap(obj => decodeURIComponent(Object.keys(obj))))];
    if (list?.includes(connectionName)) {
      dispatch(api.endpoints.deletePdc.initiate({
        account,
        direction: direction,
        name: encodeURIComponent(connectionName),
      }, { forceRefetch: true })).then((res) => {
        setConfirmModal(false);
        if (res?.data?.current_state === "SUCCESS") {
          setDoNotCall(true);
          getDetails(direction, true);
          setShowAlert({ mssg: res?.data?.message, isOpen: true, type: 'success' });
          dispatch(treeActions.setPdcListUpdated({ status: true }));
          setOldPdc('');
        } 
        if (res?.data?.current_state === 'ERROR') setShowAlert({ mssg: res.data.message, isOpen: true, type: 'error' });
      });
    } else {
      const rows = findRows(pdcConnectionList);
      if (rows.length > 0) {
        setFilteredRows(rows);
        getPdc(rows[0]?.value)
      }
      setConfirmModal(false);
      setConnectionName(ref?.current);
      setDoNotCall(true);
    }
  }

  const createNewName = (value, rowData) => {
    let newName = '';
    let baseName = value;
    let counter = 1;

    if (value.startsWith('Copy of ')) {
      baseName = value.substring('Copy of '.length);
      const match = baseName.match(/(\d+)$/); // Check if the name ends with a number
      if (match) {
        counter = parseInt(match[1], 10) + 1;
        baseName = baseName.substring(0, baseName.length - match[0].length);
      }
    } else {
      newName = `Copy of ${baseName}`;
    }

    while (rowData.some(node => node.data.value === newName)) {
      newName = `Copy of ${baseName}${counter}`;
      counter++;
    }

    return newName;
  }

  const handleCopy = (value, info) => {
    setDoNotCall(false);
    const rowData = [];
    info.api.forEachNode((node) => {
      rowData.push(node);
    });

    let newName = createNewName(value, rowData);
    if (direction === 'IN' ? inConnections?.includes(newName) : outConnections?.includes(newName)) {
      handleCopy(newName, info);
    } else copyCall(newName, direction, Object.values(cloneDeep(info?.data?.data) || {})[0]);
  }

  const copyCall = (pdcName, direc, data) => {
    if (formRef.current) {
      setOldPdc('');
      createAndUpdate(data || formRef.current, pdcName, direc);
    }
  }

  const createNewNameForTransfer = (value, rowData) => {
    let newName = '';
    let baseName = value;
    let counter = 1;

    if (value.startsWith('Copy of ')) {
      baseName = value.substring('Copy of '.length);
      const match = baseName.match(/(\d+)$/); // Check if the name ends with a number
      if (match) {
        counter = parseInt(match[1], 10) + 1;
        baseName = baseName.substring(0, baseName.length - match[0].length);
      }
    } else {
      newName = `Copy of ${baseName}`;
    }

    while (rowData.some(node => node === newName)) {
      newName = `Copy of ${baseName}${counter}`;
      counter++;
    }
    return newName;
  }

  const handleTransfer = (value, info) => {
    const transferContent = Object.values(info)[0];
    let newName = '';
    setDoNotCall(false);
    if (transferRef.current !== null && matchConnections(oldConnectionDetails.current, transferRef.current)) {
      let dir = '';
      if (direction === 'IN') {
        dir = 'OUT';
        if (outRef.current?.includes(value)) {
          newName = createNewNameForTransfer(value, outRef.current);
        } else newName = value;
      } else {
        dir = 'IN';
        if (outRef.current?.includes(value)) {
          newName = createNewNameForTransfer(value, inRef.current);
        } else newName = value;
      }
      setTimeout(() => {
        if (OUT_TYPES.includes(transferContent.ADAPTER_TYPE)) transferCall(newName, dir, transferContent);
        else {
          const transferNewFTP = { ADAPTER_TYPE: 'FTP' }
          transferCall(newName, dir, transferNewFTP);
        }
        setOldPdc('');
      }, 0);
    }
  }

  const transferCall = (pdcName, direc, data) => {
    const newData = { ...data, connectionName: pdcName, pdcName, direction: direc }
    createAndUpdate(newData, pdcName, direc, false, true);
  }

  const handleCancel = () => {
    setConfirmModal(false);
    setDoNotCall(true);
  }

  const CustomCellRenderer = (info) => {
    const { value, data } = info;
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: '2rem',
        }}
      >
        {!value || /^\s*$/.test(value) ? (
          <span style={{ color: "#0000008A" }}>{t("LBL_NEW_PDC")}</span>
        ) : (
          <div className='truncated-text' title={value}>{value}</div>
        )}
        {data?.key || data?.value ? (
          <div className="flex align-center">
            <LightTooltip
              title={t('BTN_DEL_DATA_CONN')}
              arrow>
              <span style={{ cursor: 'pointer' }} className="DELETE_MUI" onClick={() => handleDelete(value, data?.data)}></span>
            </LightTooltip>
            <LightTooltip
              title={t('COPY_PDC_CONNECTION')}
              arrow>
              <span style={{ cursor: 'pointer' }} className="FILE_COPY" onClick={() => handleCopy(value, info)}></span>
            </LightTooltip>
            {direction === 'IN' && <LightTooltip
              title={t('COPY_PDC_SRC_DES')}
              arrow>
              <span style={{ cursor: 'pointer' }} className="TAB_MOVE" onClick={() => handleTransfer(value, data?.data)}></span>
            </LightTooltip>}
            {direction === 'OUT' && <LightTooltip
              title={t('COPY_PDC_DES_SRC')}
              arrow>
              <span style={{ cursor: 'pointer', transform: 'rotateY(180deg)' }} className="TAB_MOVE" onClick={() => handleTransfer(value, data?.data)}></span>
            </LightTooltip>}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  const onGridReady = (params) => {
    if (params && params.api) {
      gridApiRef.current = params.api;
      setGridApi(params.api);
    }
  };

  const addNewAfterHandler = (e) => {
    if (e.api && ref.current !== undefined && connectionName !== null) {
      e.api.redrawRows();
    }
  }

  const gridOptions = {
    columnDefs: [
      {
        addNewControl: showAddIcon,
        addControlLabel: t('LBL_ADD_NEW_PDC'),
        addNewAfterHandler: addNewAfterHandler,
        headerName: t('LBL_CONN_NAME'),
        field: "value",
        editable: (params) => !params.data.value,
        cellRenderer: (info) => CustomCellRenderer(info, connectionName),
        headerClass: 'custom-header'
      },
    ],
    suppressMovableColumns: true,
    onFirstDataRendered: onGridReady,
  };

  const gridOptions2 = {
    columnDefs: [
      {
        addNewControl: false,
        addControlLabel: t('LBL_REMOVE_SEARCH'),
        headerName: t('LBL_CONN_NAME'),
        field: "value",
        editable: (params) => !params.data.value,
        cellRenderer: (info) => CustomCellRenderer(info, connectionName),
        headerClass: 'custom-header'
      },
    ],
    suppressMovableColumns: true,
    onFirstDataRendered: onGridReady,
  };

  const findRows = (data) => {
    let rows = [];
    if (data?.length !== 0) {
      rows = data?.map((item, index) => {
        const value = decodeURIComponent(Object.keys(item)[0]);
        return { id: index, value: value, data: item };
      });
      rows?.push({ id: rows.length, value: '', data: {} });
    } else {
      rows?.push({ id: 0, value: '', data: {} })
    }
    return rows;
  }

  const updateInAndOutConnections = (rows) => {
    const inPdc = [];
    const outPdc = [];
    for (let i = 0; i < rows?.length; i++) {
      if (rows[i]?.data[rows[i]?.value]?.direction === 'IN') {
        inPdc.push(rows[i]?.value)
      }
      if (rows[i]?.data[rows[i]?.value]?.direction === 'OUT') {
        outPdc.push(rows[i]?.value)
      }
    }
    setInConnections(inPdc);
    setOutConnections(outPdc);
  }

  const filterByName = (data, searchText) => {
    if (searchText === '' && data?.length > 0) setFilteredRows(data);
    else {
      let rows = [];
      if (filteredData?.length !== 0) {
        rows = filteredData?.filter((row) => row?.value?.toLowerCase().includes(searchText.toLowerCase()));
      } else rows = data?.filter((row) => row?.value?.toLowerCase().includes(searchText.toLowerCase()));
      if (rows?.length > 0) {
        setSearchBtn(true)
        setSelectedIndex(0);
      } else {
        setSelectedIndex(null);
        setSearchBtn(false)
      }
      setFilteredRows(rows);
    }
  }

  const filterByValue = (data, searchText) => {
    if (searchText === '') {
      const rows = findRows(data);
      if (rows?.length > 0) setFilteredRows(rows);
    } else {
      let details = [];
      if (filteredValueData?.length !== 0) {
        details = filteredValueData?.filter((row) => {
          const valuesToSearch = Object.values(Object.values(row)[0]);
          return valuesToSearch.some(value =>
            typeof value === 'string' &&
            value.includes(searchText)
          );
        });
      } else {
        details = data?.filter((row) => {
          const valuesToSearch = Object.values(Object.values(row)[0]);
          return valuesToSearch.some(value =>
            typeof value === 'string' &&
            value.includes(searchText)
          );
        });
      }
      const rows = findRows(details);
      if (rows?.length > 0) {
        setSearchBtn(true)
        setSelectedIndex(0);
      } else {
        setSelectedIndex(null);
        setSearchBtn(false)
      }
      if (rows?.length > 0) {
        rows.pop();
        if (rows?.length === 0) setSearchBtn(false);
        setFilteredRows(rows);
      }
    }
  }

  const onFilterByConnectionType = (searchValue) => {
    let rows = [];
    if (searchValue !== '' && searchValue !== null) {
      const data = pdcDetails?.filter((row) => {
        const adapterType = Object.values(row)[0]?.ADAPTER_TYPE;
        return (
          adapterType === searchValue ||
          (adapterType === 'BridgeGate Web Service' && searchValue === 'BridgeGate Web Service') ||
          (adapterType === 'BridgeGateWebService' && searchValue === 'BridgeGate Web Service')
        );
      });
      rows = findRows(data);
      setFilteredData(rows);
      setFilteredValueData(data);
    } else {
      rows = findRows(pdcDetails);
      setFilteredData(rows);
      setFilteredValueData(pdcDetails)
    }
    if (rows?.length !== 0) {
      getPdc(rows[0]?.value || '');
      setConnectionName(rows[0]?.value || '');
      ref.current = rows[0]?.value;
    }
    if (rows?.length > 0) setFilteredRows((rows));
  }

  const handleSearch = () => {
    setShowAddIcon(false);
    search(searchItem);
  }

  const handleNext = () => {
    if (throttleTimeout) {
      return;
    }

    if (selectedIndex < filtertedRows.length - 1) {
      setSelectedIndex(prevIndex => prevIndex + 1);
    } else {
      if (filtertedRows?.length > 0) setFilteredRows(filtertedRows);
      setConnectionName(filtertedRows[selectedIndex]?.value || '');
      ref.current = filtertedRows[selectedIndex]?.value
      setSelectedIndex(null);
      setSearchBtn(false);
    }

    setThrottleTimeout(setTimeout(() => setThrottleTimeout(null), 500));
  };

  const search = (text) => {
    if (filterBy === 'name') filterByName(rowData, text);
    else if (filterBy === 'value') filterByValue(pdcDetails, text);
  }

  const applyHandler = () => {
    setContent(newConnectionDetails);
    setConnectionDetails((prev) => {
      return { ...prev, ...newConnectionDetails }
    })
    oldConnectionDetails.current = newConnectionDetails;
    updatePdcDetails();
    setApplyChanges(false);
  }

  const handleApplyCancel = () => {
    setContent(connectionDetails);
    setApplyChanges(false);
    highlightPdcRow(oldPdc);
    setConnectionName(oldPdc);
    setConnectionDetails((prev) => {
      return { ...prev, ...connectionDetails, connectionName: oldPdc }
    });
    oldConnectionDetails.current = { ...connectionDetails, connectionName: oldPdc }
  }

  const handleSavedChanges = () => {
    const trimmedConnectionName = (connectionName || "").trim();
    const content = { ...newConnectionDetails, ADAPTER_TYPE: connectionType, connectionName: trimmedConnectionName, direction };
    createAndUpdate(content, trimmedConnectionName, direction);
    setSavedChanges(false);
  }

  const handleCancelSavedChanges = () => {
    const content = { ...newConnectionDetails, ADAPTER_TYPE: connectionType, connectionName, direction };
    setConnectionDetails(content);
    oldConnectionDetails.current = content;
    setSavedChanges(false);
  }

  function hasOnlyAdapterTypeKey(obj) {
    if (typeof obj !== 'object' || obj === null) {
      return false;
    }
    const keys = Object.keys(obj);
    return keys.length === 1 && keys[0] === 'ADAPTER_TYPE';
  }

  const handleRow = (options) => {
    const { value } = options?.data;
    const list = [...new Set(pdcConnectionList.flatMap(obj => decodeURIComponent(Object.keys(obj))))];
    if (value !== '' && list.includes(connectionName) && !matchConnections(connectionDetails, newConnectionDetails) && !hasOnlyAdapterTypeKey(newConnectionDetails)) {
      setApplyChanges(true);
      return;
    } else {
      if (list.includes(value)) {
        setOldPdc(value);
        setCheckNode(options?.data);
        if (value && doNotCall) {
          getPdc(value);
          setConnectionName(value);
          setPdcSelected(false);
          setContentLoading(true);
        }
      } else if (value !== '') {
        setSavedChanges(true);
        return;
      }

      // Refresh cells after setting the current node
      options.api.refreshCells({
        force: true,
        suppressFlash: true,
      });
    }
  };

  function removeEmptyValues(obj) {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
    );
  }


  const handleBodyContent = (val) => {
    if (val !== null) {
      setNewConnectionDetails(removeEmptyValues({ ...val, ADAPTER_TYPE: connectionType }));
      transferRef.current = removeEmptyValues({ ...val, ADAPTER_TYPE: connectionType });
    }
    if (val !== null) setContent(removeEmptyValues({ ...val }));
  }

  const matchConnections = (a, b) => {
    if (a === b) return true;
    if (typeof a !== 'object' || a === null || typeof b !== 'object' || b === null) {
      return false;
    }
    if (Array.isArray(a) !== Array.isArray(b)) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (let key of keysA) {
      if (!keysB.includes(key) || !matchConnections(a[key], b[key])) {
        return false;
      }
    }
    return true;
  };

  const updatePdcDetails = () => {
    const trimmedConnectionName = (connectionName || "").trim();

    if (connectionName !== trimmedConnectionName) {
      setConnectionName(trimmedConnectionName);
    }

    // Validate connection name is not empty
    if (!trimmedConnectionName) {
      // Trigger global toast event
      window.dispatchEvent(new CustomEvent('showToast', {
        detail: {
          message: t('PREDEFINED_CONNECTION_NAME_CANNOT_BE_EMPTY'),
          severity: "warning"
        }
      }));
      return;
    }

    const body = { ...content, ADAPTER_TYPE: connectionType, connectionName: trimmedConnectionName, direction: direction }

    // GraphQL required defaults when missing
    if (connectionType === "GraphQL") {
      if (!body.CONTENT_TYPE) body.CONTENT_TYPE = "application/json";
      if (!body.REQUEST_TYPE) body.REQUEST_TYPE = "POST";
      if (!body.SSL_TYPE) body.SSL_TYPE = "TLSv1";
    } else if (connectionType === "JMS") {
      if (!body.DESTINATION_TYPE) body.DESTINATION_TYPE = "QUEUE";
    } else if (connectionType === "HTTP") {
      if (!body.SSL_TYPE) body.SSL_TYPE = "TLSv1.2";
      if (!body.URLENCODE) body.URLENCODE = "TRUE";
    }
    createAndUpdate(body, trimmedConnectionName, direction, true);
  }

  const checkDuplicateKey = (id, value, gridApi) => {
    if (!value) return false;
    let duplicateFound = false;
    gridApi.forEachNode((node) => {
      if (node.data.id !== id && node.data.value === value) duplicateFound = true;
    });
    return duplicateFound;
  };

  function createEmptyObject(originalObject) {
    const emptyObject = {};

    // Loop through the keys of the original object
    for (const key in originalObject) {
      // Check if the key is a direct property of the object (not inherited)
      if (originalObject.hasOwnProperty(key)) {
        // Assign an empty value to the corresponding key in the new object
        emptyObject[key] = '';
      }
    }
    return { ...emptyObject, connectionType: connectionType};
  }

  const handleCellValueChanged = (gridOptions) => {
    const { value, id } = gridOptions?.data;
    const rowIndex = gridOptions.rowIndex;
    const colId = gridOptions.column.colId;
    const rowNode = gridApi.getRowNode(rowIndex);
    setCurrentNode(rowNode);
    if (value) {
      const trimmedValue = value.trim();
      
      // Check if value contains only whitespace
      if (trimmedValue === '') {
        setErrorModal(true);
        setErrorMessage(t('BOX_ENTER_NAME_FOR_PDC'));
        const rowNode = gridOptions.api.getDisplayedRowAtIndex(rowIndex);
        rowNode.setDataValue(colId, gridOptions?.oldValue || "");
        return;
      }
      
      // If value has leading/trailing spaces, trim it
      if (value !== trimmedValue) {
        setTimeout(() => {
          const rowNode = gridOptions.api.getDisplayedRowAtIndex(rowIndex);
          if (rowNode) {
            rowNode.setDataValue(colId, trimmedValue);
          }
        }, 50);
        return;
      }
      
      const isDuplicateKey = checkDuplicateKey(id, trimmedValue, gridOptions.api);
      if (isDuplicateKey) {
        setErrorModal(true);
        setErrorMessage(t('BOX_NAME_ALREADY_EXISTS'));
        const rowNode = gridOptions.api.getDisplayedRowAtIndex(rowIndex);
        rowNode.setDataValue(colId, gridOptions?.oldValue || "");
      } else {
        if (pdcConnection) {
          setConnectionName(trimmedValue);
          ref.current = trimmedValue;
          const adapterType = pdcConnection?.props?.ADAPTER_TYPE || '';
          setConnectionType(adapterType);
          setPdcSelected(false);
          const emptyObject = createEmptyObject(pdcConnection?.props);
          if (adapterType === "HTTP") {
            emptyObject.SSL_TYPE = "TLSv1.2";
            emptyObject.URLENCODE = "TRUE";
          } else if (adapterType === "GraphQL") {
            emptyObject.CONTENT_TYPE = "application/json";
            emptyObject.REQUEST_TYPE = "POST";
            emptyObject.SSL_TYPE = "TLSv1";
          } else if (adapterType === "JMS") {
            emptyObject.DESTINATION_TYPE = "QUEUE";
          }
          setAddNew(false);
          setConnectionDetails(emptyObject);
          oldConnectionDetails.current = emptyObject;
        }
      }
    }
  }

  const handleErrorModal = () => {
    setErrorModal(false);
    setErrorMessage('');
  }

  const checkDuplicateConnectionName = (connection) => {
    const isDuplicate = checkDuplicateKey(checkNode?.id, connection, gridApi);
    if (isDuplicate) {
      setErrorModal(true);
      setErrorMessage(t('BOX_NAME_ALREADY_EXISTS'));
      setConnectionDetails((prev) => {
        return { ...prev, connectionName: ref.current }
      });
      oldConnectionDetails.current = connectionDetails;
      setNewConnectionDetails((prev) => {
        return { ...prev, connectionName: ref.current }
      });
      transferRef.current = newConnectionDetails;
      setConnectionName(ref.current);
    }
  }

  const debounceCheckDuplicateConnectionName = debounce(checkDuplicateConnectionName, 300);

  const createAndUpdate = (body, value, dir, update = false, transfer = false) => {
    const trimmedValue = (value || "").trim();
    setContentLoading(true);
    setDoNotCall(true);
    if (trimmedValue) {
      if(body?.ADAPTER_TYPE === t('DATA_STREAM') || body?.ADAPTER_TYPE === 'Data Stream'){
        body = {
          ...body,
          CWF_WF_GROUP: body.hasOwnProperty('CWF_WF_GROUP') ? body.CWF_WF_GROUP : (leftSelectedNode?.type === 'workflowGroup' ? leftSelectedNode?.title : leftSelectedNode?.workflowGroup),
          CWF_RUN_DISTRIBUTED: body.CWF_RUN_DISTRIBUTED || "FALSE"
        };
      }
      dispatch(api.endpoints.createPdc.initiate({
        account,
        direction: dir,
        oldPdcName: update && addNew ? encodeURIComponent(oldPdc) : '',
        name: encodeURIComponent(trimmedValue),
        body: encryption(body)
      }, { subscribe: false })).then(res => {
        setContentLoading(false);
        setFilterByConnectionType('');
        if (res?.data?.current_state === "SUCCESS") {
          setShowAlert({ mssg: res?.data?.message, isOpen: true, type: 'success' });
          getDetails(direction);
          if (!transfer) getPdc(value);
          dispatch(treeActions.setPdcListUpdated({ status: true }));
          setTimeout(() => {
            if(screen && screen === 'GET_DATA'){
              handleClose();
            }
          }, 10);
        } 
        if (res?.data?.current_state === 'ERROR') setShowAlert({ mssg: res.data.message, isOpen: true, type: 'error' });
        setAddNew(true);
        setLoading(false);
      });
    } else setLoading(false)
  }

  const getPdc = (value) => {
    ref.current = value
    if (value) {
      dispatch(api.endpoints.getPdcDetail.initiate({
        account,
        direction: direction,
        name: encodeURIComponent(value)
      }, { forceRefetch: true })).then(res => {
        if (res?.data?.current_state === 'SUCCESS' && res?.data?.data) {
          dispatch(treeActions.setCurrentPdcConnectionDetail({
            screen: 'inbound',
            value: res?.data?.data
          }));
          setPdcSelected(false);
          setConnectionName(decodeURIComponent(res?.data?.data?.name));
          setOldPdc(res?.data?.data?.name);
          ref.current = decodeURIComponent(res?.data?.data?.name);
          highlightPdcRow(ref.current);
          let newdata = res?.data?.data?.props;
          if (newdata) {
            newdata = decryption(res?.data?.data?.props);
          }
          setConnectionDetails(removeEmptyValues({ ...newdata, connectionName: oldPdc }));
          oldConnectionDetails.current = removeEmptyValues({ ...newdata, connectionName: oldPdc });
          setNewConnectionDetails(removeEmptyValues({ ...newdata, connectionName: oldPdc }));
          transferRef.current = removeEmptyValues({ ...newdata, connectionName: oldPdc });
          setContent(newdata);
          if (res?.data?.data?.props?.ADAPTER_TYPE === 'BridgeGate Web Service') {
            setConnectionType(res?.data?.data?.props?.ADAPTER_TYPE || '');
          } else if (res?.data?.data?.props?.ADAPTER_TYPE === 'BridgeGateWebService') {
            setConnectionType(t(res?.data?.data?.props?.ADAPTER_TYPE) || '');
          } else setConnectionType(res?.data?.data?.props?.ADAPTER_TYPE || '');
        } 
        if (res?.data?.current_state === 'ERROR') setShowAlert({ mssg: res.data.message, isOpen: true, type: 'warning' });
        setContentLoading(false);
      })
    } else {
      setContentLoading(false)
      setLoading(false)
    }
  }

  const getDetails = (direction, firtCall = false) => {
    setLoading(true);
    dispatch(api.endpoints.getAllPdcDetail.initiate(
      {
        account,
        direction: direction,
      },
      { forceRefetch: true }
    )).then((res) => {
      if (res?.data?.current_state === 'ERROR' || !res?.data?.predefined_connections) {
        setConnectionName('');
        setConnectionType('');
        setPdcSelected(true);
        setConnectionDetails({});
        oldConnectionDetails.current = null;
        setNewConnectionDetails({});
        transferRef.current = null;
        setContent({});
        const rows = findRows([]);
        if (rows?.length > 0) {
          setRowData(rows);
          setFilteredRows((rows));
        }
        dispatch(treeActions.setPdcConnectionsList({
          screen: 'inbound',
          value: []
        }));
      } else {
        const rows = findRows(res?.data?.predefined_connections || []);
        if (rows?.length > 0) {
          setRowData(rows);
          setFilteredRows((rows));
          updateInAndOutConnections(rows);
        }
        setPdcDetails(res?.data?.predefined_connections || []);
        dispatch(treeActions.setPdcConnectionsList({
          screen: 'inbound',
          value: res?.data?.predefined_connections || []
        }));
        if (firtCall && rows?.length !== 0) {
          if (currTab === 1 && direction === 'OUT') {
            if (pdcConnectionName !== null && pdcConnectionName !== '' && pdcConnectionName !== '-- Select --') {
              getPdc(pdcConnectionName);
              if (rows?.length !== 0) {
                const currentRow = rows?.filter((row) => pdcConnectionName === row?.value);
                setConnectionName(pdcConnectionName || '');
                ref.current = decodeURIComponent(pdcConnectionName || '');
                setSelectedIndex(currentRow[0]?.id);
                setCheckNode(currentRow[0]);
              }
            } else {
              getPdc(rows[0]?.value || '');
              setConnectionName(rows[0]?.value || '');
              setCheckNode(rows[0]);
              ref.current = decodeURIComponent(rows[0]?.value || '');
              highlightPdcRow(ref.current);
            }
          } else {
            const currentRow = rows?.filter((row) => pdcConnectionName === row?.value);
            getPdc(pdcConnectionName || rows[0]?.value || '');
            setConnectionName(pdcConnectionName || rows[0]?.value || '');
            // setCheckNode(rows[0]);
            setCheckNode(currentRow[0])
            ref.current = decodeURIComponent(pdcConnectionName || rows[0]?.value || '');
            highlightPdcRow(ref.current);
          }
        }
      }
      gridApi?.refreshCells();
      setLoading(false);
    })
  }

  const getPdcList = (dir) => {
    dispatch(api.endpoints.getAllPdcDetail.initiate(
      {
        account,
        direction: dir,
      },
      { forceRefetch: true }
    )).then((res) => {
      if (res?.data?.current_state !== 'ERROR' || res?.data?.predefined_connections) {
        const rows = findRows(res.data.predefined_connections);
        if (rows.length > 0) {
          inRef.current = rows?.map((row) => row.value !== '' ? row.value: '');
          outRef.current = rows?.map((row) => row.value !== '' ? row.value: '');
        }
      }
    })
  }

  const connectionTypeDropDownItems = types.map((obj, key) => (
    <MenuItem key={key} value={t(obj)}>
      {t(obj)}
    </MenuItem>
  ));

  const toggle = (val) => {
    setTest(val);
  }

  const handleAlertClose = () => {
    setShowAlert({ ...showAlert, isOpen: false });
  }

  function highlightPdcRow(val) {
    if (gridApi && val) {
      requestAnimationFrame(() => {
        gridApi.forEachNode((node) => {
          if (node?.data?.value === val) {
            node.setSelected(true);
            gridApi.ensureNodeVisible(node);
          }
        });
      });
    }
  }

  const handleClear = () => {
    setShowAddIcon(true);
    setFilteredValueData([]);
    setFilteredData([]);
    setFilterByConnectionType('');
    setSearchItem('');
    setSearchBtn(false);
    setCheckNode(null);
    if (rowData?.length > 0) setFilteredRows(rowData);
  }

  const scrollRows = () => {
    if (gridApi && selectedIndex !== undefined) {
      const rowNode = gridApi.getRowNode(selectedIndex);
      if (rowNode) {
        rowNode.setHighlighted(true);
        gridApi.ensureIndexVisible(selectedIndex, 'current');
      }
    }
  };
  
  const handlePdcSelectButton = () => {    
    const selectedPdcData = {
      connectionName: connectionName,
      connectionType: connectionType,
      connectionDetails: connectionDetails,
      direction: direction,
      pdcConnection: pdcConnection,
      currentConnectionFromList: pdcConnectionList?.find(conn => 
        decodeURIComponent(Object.keys(conn)[0]) === connectionName
      )
    };

    if (onPdcSelect) {
      onPdcSelect(selectedPdcData);
      setShowAlert({ 
        mssg: `${connectionType} connection "${connectionName}" has been selected successfully`, 
        isOpen: true, 
        type: 'success' 
      });
      
      setTimeout(() => {
        handleClose();
      }, 1000);
    }
  }

  useEffect(() => {
    if (gridApi && currentNode && currentNode.data) {
      const id = currentNode.data.id;
      // Use setTimeout to ensure the scroll operation occurs after the current event loop
      setTimeout(() => {
        // Ensure that gridApi and currentNode are still valid before scrolling
        if (gridApi.getRowNode(id)) {
          // Scroll to the row with the specified ID, positioning it in the middle
          gridApi.ensureIndexVisible(id, 'middle');
        }
      }, 0);
    }
  }, [currentNode, gridApi]);

  useEffect(() => {
    const formBody = { ...content }
    formRef.current = formBody;
    setContent(content)
  }, [content])

  useEffect(() => {
    if (direction === 'IN' && currTab === 0) getDetails('IN', true);
    if (direction === 'OUT' && currTab === 1) getDetails('OUT', true);
    if (connectionName === '') setPdcSelected(true);
    handleClear();
  }, [currTab]);

  useEffect(() => {
    if (direction === 'IN' && currTab === 0)
      getPdcList('OUT');
    if (direction === 'OUT' && currTab === 1)
      getPdcList('IN');
  }, [currTab, rowData]);

  useEffect(() => {
    dispatch(api.endpoints.getAdapterList.initiate({
      direction
    })).then((res) => {
      if (res?.data?.current_state === 'SUCCESS') setTypes(Object.keys(res.data.data));
      if (res?.data?.current_state === 'ERROR') setShowAlert({ mssg: 'Unknown Action', isOpen: true, type: 'error' });
    })
  }, [direction]);

  useEffect(() => {
    if (filterByConnectionType !== '' && searchItem === '') {
      if(screen === "GET_DATA" || screen === "SEND_DATA") setDisableSelect(false);
      else{
        if(filterByConnectionType === "DATABASE") setDisableSelect(false);
        else setDisableSelect(true);
      } 
      onFilterByConnectionType(filterByConnectionType);
    }
  }, [filterByConnectionType]);

  useEffect(() => {
    if (filterBy === 'name') filterByName(rowData, searchItem);
    else if (filterBy === 'value') filterByValue(pdcDetails, searchItem);
  }, [filterBy]);

  useEffect(() => {
    if (selectedIndex !== null && containerRef.current) {
      const searchItem = filtertedRows[selectedIndex]?.value;
      if (searchItem) {
        setConnectionName(searchItem);
        ref.current = searchItem;
        getPdc(searchItem);
      }
    }
    if (containerRef.current) {
      const itemHeight = 40;
      const containerHeight = containerRef.current.clientHeight;
      const scrollTo = selectedIndex * itemHeight;

      if (scrollTo > containerHeight) {
        containerRef.current.scrollTop = scrollTo;
        setTimeout(() => {
          scrollRows();
        }, 0);
      }
    }
  }, [selectedIndex, filtertedRows]);

  useEffect(() => {
    if (gridApi && ref.current && connectionName) {
      if (typeof gridApi.redrawRows === 'function') {
        try {
          setTimeout(function () { gridApi?.redrawRows(); }, 0); //avoiding ag-grid error of redrawing grid while updating data.
        } catch (e) {
          console.warn(e);
        }
      } else {
        console.warn("gridApi.redrawRows is not a function");
      }
    }
  }, [gridApi, connectionName]);

  useEffect(() => {
    highlightPdcRow(ref.current);
  }, [ref.current, gridApi, rowData]);

  useEffect(() => {
    if (searchItem === '' && rowData?.length > 0) {
      setFilteredRows(rowData);
    }
    setSearchBtn(false);
  }, [searchItem]);

  useEffect(() => {
    (screen === "GET_DATA" || screen === "SEND_DATA") ? setDisableSelect(false) : setDisableSelect(true);
  },[screen])

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Box sx={{ boxSizing: "border-box", height: "100%" }}>
            {/* parent div */}
            <div className='pdc-container'>
              {/* left side container */}
              <div className="table-border pdc-left-container">
                <div className="pdc-left-inner">
                  {/* search field */}
                  <div className="flex space-between align-center width-100">
                    <Stack direction={"row"} spacing={"4px"}>
                      <div className="search-container flex">
                        <div className="search" style={{ height: "34px" }}>
                          <InputBase
                            variant="outlined"
                            className="search-input width-100"
                            placeholder={t("FIND_PDC")}
                            value={searchItem || ""}
                            onChange={(e) => {
                              setSearchItem(e.target.value);
                            }}
                            endAdornment={
                              <IconButton onClick={handleClear} size="small">
                                <ClearIcon
                                  style={{ fontSize: "15px", padding: "0" }}
                                />
                              </IconButton>
                            }
                          />
                          {!searchBtn && (
                            <Button size="small" onClick={handleSearch}>
                              {t("DIAG_SEARCH_FIND")}
                            </Button>
                          )}
                          {searchBtn && (
                            <Button size="small" onClick={handleNext}>
                              {t("NEXT")}
                            </Button>
                          )}
                          <LightTooltip title="Search Options" arrow>
                            <Button
                              size="small"
                              className='pdc-btn'
                              aria-haspopup="true"
                              startIcon={<FilterListOutlinedIcon />}
                              onClick={handleSearchOptionClick}>
                              {filterBy === "name"
                                ? t("COL_NAME")
                                : t("COL_VAL")}
                            </Button>
                          </LightTooltip>
                          <Menu
                            id="search-options-menu"
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => handleMenuClose()}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            MenuListProps={{
                              "aria-labelledby": "search-options-button",
                            }}>
                            <MenuItem
                              onClick={() => handleMenuItemClick("name")}>
                              <FormControlLabel
                                value="name"
                                control={
                                  <Radio checked={filterBy === "name"} />
                                }
                                label={t("COL_NAME")}
                              />
                            </MenuItem>
                            <MenuItem
                              onClick={() => handleMenuItemClick("value")}>
                              <FormControlLabel
                                value="value"
                                control={
                                  <Radio checked={filterBy === "value"} />
                                }
                                label={t("COL_VAL")}
                              />
                            </MenuItem>
                          </Menu>
                        </div>
                      </div>
                    </Stack>
                  </div>
                  {/* Filter by connection type */}
                  <FormControl className="width-100" size="small">
                    <Autocomplete
                      disablePortal
                      options={types.map((e) => t(e))}
                      value={filterByConnectionType || ''}
                      sx={{ padding: "0 4px" }}
                      onChange={(e, value) => {
                        onFilterByConnectionType(value);
                        setFilterByConnectionType(value || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          id="custom-css-outlined-input"
                          {...params}
                          label={t("FILTER BY CONNECTION TYPE")}
                          value={filterByConnectionType || ''}
                          onChange={(e) => {
                            onFilterByConnectionType(e.target.value);
                            setFilterByConnectionType(e.target.value || '');
                          }}
                          size="small"
                          name={"FILTER_BY_CONNECTION_TYPE"}
                        />
                      )}
                    />
                  </FormControl>
                  {/* Connection list */}
                  {rowData && showAddIcon && (
                    <div
                      ref={containerRef}
                      className="padding-hor-4"
                      id="pdc-grid"
                      style={{ height: "100%" }}>
                      <CommonGrid
                        gridOptions={gridOptions}
                        rowData={filtertedRows}
                        getGridAPI={(gridOptions, gridApi) =>
                          setGridApi(gridApi.api)
                        }
                        containerStyle={{
                          height: "100%",
                        }}
                        gridProps={{
                          onRowClicked: handleRow,
                          onCellValueChanged: handleCellValueChanged,
                          rowSelection: "single",
                        }}
                      />
                    </div>
                  )}
                  {rowData && !showAddIcon && (
                    <div
                      ref={containerRef}
                      className="padding-hor-4"
                      id="pdc-grid"
                      style={{ height: "100%" }}>
                      <CommonGrid
                        gridOptions={gridOptions2}
                        rowData={filtertedRows}
                        getGridAPI={(gridOptions, gridApi) =>
                          setGridApi(gridApi.api)
                        }
                        containerStyle={{
                          height: "100%",
                        }}
                        gridProps={{
                          onRowClicked: handleRow,
                          onCellValueChanged: handleCellValueChanged,
                          rowSelection: "single",
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              {/* rightside container */}
              {contentLoading ? (
                <Loader />
              ) : (
                <div className='pdc-right-container table-border flex'>
                  <div className='pdc-right-inner'>
                    <Stack spacing={"15px"} className="tp-segment width-100">
                      <FormControl className="width-100" size="small">
                        <TextField
                          variant="outlined"
                          size="small"
                          label={t("LBL_CONN_NAME")}
                          type="text"
                          value={connectionName || ""}
                          autoComplete="off"
                          onChange={(e) => {
                            setConnectionName(e.target.value);
                            debounceCheckDuplicateConnectionName(
                              e.target.value
                            );
                            return {
                              connectionName: e.target.value,
                            };
                          }}
                            onBlur={() => {
                            setConnectionName(prev => {
                              const trimmed = (prev || "").trim();
                              return trimmed;
                            });
                          }}
                          className={"width-100"}
                          name={"CONN_NAME"}
                          disabled={pdcSelected}
                        />
                      </FormControl>
                      <FormControl
                        variant="outlined"
                        className="width-100"
                        size="small"
                        disabled={pdcSelected}>
                        <InputLabel id="connectionTypeDropdownLabel">
                          {t("LBL_CONN_TYPE")}
                        </InputLabel>
                        <Select
                          className={"width-100"}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                maxHeight: 300,
                              },
                            },
                          }}
                          name={"CONNECTION_TYPE"}
                          labelId="connectionTypeDropdownLabel"
                          label={t("LBL_CONN_TYPE")}
                          value={connectionType || ""}
                          onChange={(e) => {
                            let newConnectionDetails = {ADAPTER_TYPE: e.target.value};
                            if(e.target.value === "HTTP") {
                              newConnectionDetails.SSL_TYPE = "TLSv1.2";
                              newConnectionDetails.URLENCODE = "TRUE";
                            }
                            setConnectionDetails(newConnectionDetails);
                            oldConnectionDetails.current = null;
                            setNewConnectionDetails({});
                            transferRef.current = null;
                            setConnectionType(e.target.value);
                            setContent(null);
                          }}
                          id="connectionTypeDropdown">
                          {connectionTypeDropDownItems}
                        </Select>
                      </FormControl>
                      {connectionType === "ActiveMQ" && (
                        <ActiveMQ
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                        />
                      )}
                      {connectionType === "AmazonSQS" && (
                        <AmazonSQS
                          direction={direction}
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                        />
                      )}
                      {connectionType === "AS2" && (
                        <As2
                          direction={direction}
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                        />
                      )}
                      {connectionType === "Azure" && (
                        <Azure
                          direction={direction}
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                        />
                      )}
                      {(connectionType === "Google Cloud Storage" ||
                        connectionType === "Google_Cloud_Storage"
                      ) && (
                        <GoogleCloudStorage
                          direction={direction}
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                        />
                      )}
                      {(connectionType === "BridgeGate Web Service" ||
                        connectionType === "BridgeGateWebService") && (
                          <BridgeGateWebService
                            connectionDetails={connectionDetails}
                            handleBodyContent={handleBodyContent}
                            source="pdc"
                          />
                        )}
                      {connectionType === t("BridgeGateFTP") && (
                        <BridgeGateFTP
                          connectionType={connectionType}
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                          direction={direction}
                        />
                      )}
                      {connectionType === t("BridgeGateSocket") && (
                        <BridgeGateSocket
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                        />
                      )}
                      {connectionType === t("Command_Prompt") && (
                        <Cmd
                          direction={direction}
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                        />
                      )}
                      {connectionType === t("DATABASE") && (
                        <Database
                          direction={direction}
                          connectionDetails={connectionDetails}
                          account={account}
                          connectionName={connectionName}
                          open={test}
                          close={toggle}
                          handleBodyContent={handleBodyContent}
                          source="pdc"
                        />
                      )}
                      {connectionType === t("DATA_STREAM") && (
                        <DataStream
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                        />
                      )}
                      {connectionType === t("EMAIL") && (
                        <Email
                          direction={direction}
                          connectionDetails={connectionDetails}
                          connectionName={connectionName}
                          account={account}
                          handleBodyContent={handleBodyContent}
                          source="pdc"
                        />
                      )}
                      {connectionType === t("FILE") && (
                        <File
                          direction={direction}
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                        />
                      )}
                      {connectionType === t("FTP") && (
                        <FTP
                          direction={direction}
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                          account={account}
                          connectionName={connectionName}
                          open={test}
                          close={toggle}
                          source="pdc"
                        />
                      )}
                      {connectionType === t("HTTP") && (
                        <Http
                          direction={direction}
                          connectionDetails={connectionDetails}
                          connectionName={connectionName}
                          account={account}
                          handleBodyContent={handleBodyContent}
                          source="pdc"
                        />
                      )}
                      {connectionType === t("JMS") && (
                        <JMS
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                          source="pdc"
                        />
                      )}
                      {connectionType === t("Kafka") && (
                        <Kafka
                          direction={direction}
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                          account={account}
                          source="pdc"
                        />
                      )}
                      {(connectionType === "MQ Series" ||
                        connectionType === t("BridgeGateMQSeries")) && (
                          <MqSeries
                            direction={direction}
                            connectionDetails={connectionDetails}
                            handleBodyContent={handleBodyContent}
                            source="pdc"
                          />
                        )}
                      {(connectionType === "MSMQ" ||
                        connectionType === t("BridgeGateMSMQ")) && (
                          <Msmq
                            direction={direction}
                            connectionDetails={connectionDetails}
                            handleBodyContent={handleBodyContent}
                            source="pdc"
                          />
                        )}
                      {connectionType === "SOCKET" && (
                        <Socket
                          direction={direction}
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                          account={account}
                        />
                      )}
                      {connectionType === "SSH" && (
                        <Ssh
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                          direction={direction}
                          account={account}
                          source="pdc"
                        />
                      )}
                      {connectionType === t("Web_Service") && (
                        <WebService
                          direction={direction}
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                          account={account}
                        />
                      )}
                      {connectionType === t("Synchronous Response") && (
                        <SendDataControls
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                          direction={direction}
                        />
                      )}
                      {(connectionType === "GraphQL") && (
                        <GraphQL
                          connectionDetails={connectionDetails}
                          handleBodyContent={handleBodyContent}
                          direction={direction}
                          account={account}
                          connectionName={connectionName}
                          source="pdc"
                        />
                      )}
                    </Stack>
                  </div>
                  {!pdcSelected && (
                    <div
                      style={{ padding: "10px" }}
                      className="flex space-between">
                      {[t("DATABASE"), t("FTP")].includes(connectionType) && (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => setTest(true)}>
                          {t("BTN_TEST_CONNECTION")}
                        </Button>
                      )}
                      <div className="flex" style={{ gap: "5px" }}>
                        {origin !== "repository" && source !== "repository_management" && <Button
                          size="small"
                          variant="outlined"
                          disabled={!connectionDetails?.ADAPTER_TYPE || (disableSelect && connectionDetails?.ADAPTER_TYPE !== 'DATABASE')}
                          onClick={handlePdcSelectButton}
                          >
                          {t("BTN_PDC_SELECT")}
                        </Button>}
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={updatePdcDetails}
                          disabled={![...types, 'BridgeGate Web Service'].includes(connectionType)}>
                          {t("APPLY")}
                        </Button>
                        {source !== "repository_management" && <Button
                          size="small"
                          variant="outlined"
                          onClick={handleClose}>
                          {t("BTN_CLOSE")}
                        </Button>}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </Box>
        </>
      )}
      <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
        <Alert
          onClose={() => handleAlertClose()}
          severity={showAlert.type}
          variant="filled"
          sx={{ width: "100%" }}>
          {showAlert.mssg}
        </Alert>
      </Snackbar>
      {!contentLoading && (
        <ConfirmDeleteModal
          confirmModal={confirmModal}
          deleteHandler={deleteHandler}
          connectionType={connectionType}
          connectionName={connectionName}
          handleCancel={handleCancel}></ConfirmDeleteModal>
      )}
      {applyChanges && (
        <ConfirmApplyModal
          applyModal={applyChanges}
          applyHandler={applyHandler}
          connectionType={connectionType}
          connectionName={connectionName}
          handleApplyCancel={handleApplyCancel}
        />
      )}
      {savedChanges && (
        <ConfirmApplyModal
          applyModal={savedChanges}
          applyHandler={handleSavedChanges}
          connectionType={connectionType}
          connectionName={connectionName}
          handleApplyCancel={handleCancelSavedChanges}
        />
      )}
      {errorModal && (
        <ErrorModal
          errorModal={errorModal}
          handleErrorModal={handleErrorModal}
          errorMessage={errorMessage}></ErrorModal>
      )}
    </>
  );
}

export default ConnectionScreen;

export const ConfirmDeleteModal = ({ confirmModal, connectionType, connectionName, deleteHandler, handleCancel }) => {
  const { t } = useTranslation();
  return <>
    <Dialog
      open={confirmModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className='dialog-header'>
        <div className="title">
          {t("BOX_CONFIRM")}
        </div>
      </DialogTitle>

      <DialogContent className='modal-content' dividers>
        {t("BOX_SURE_YOU_WANT_TO_DEL").split(":")[0]}:{" "}
        <br />
        {connectionType} - {connectionName}
      </DialogContent>

      <DialogActions>
        <Button
          size='small'
          variant="outlined"
          color="primary"
          onClick={deleteHandler}>
          {t("YES")}
        </Button>
        <Button
          size='small'
          variant="outlined"
          color="primary"
          onClick={handleCancel}>
          {t("BTN_CANCEL")}
        </Button>
      </DialogActions>
    </Dialog>
  </>
}

export const ConfirmApplyModal = ({ applyModal, connectionName, applyHandler, handleApplyCancel }) => {
  const { t } = useTranslation();
  return <>
    <Dialog
      open={applyModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className='dialog-header'>
        <div className="title">
          {t("BOX_CONFIRM")}
        </div>
      </DialogTitle>

      <DialogContent className='modal-content' dividers>
        {t('THERE_ARE_UNSAVED_CHANGES_MADE_TO')?.split('{0}').join(' ')} - <span className="bold">{connectionName}</span>
      </DialogContent>

      <DialogActions>
        <Button
          size='small'
          variant="outlined"
          color="primary"
          onClick={applyHandler}>
          {t("APPLY")}
        </Button>
        <Button
          size='small'
          variant="outlined"
          color="primary"
          onClick={handleApplyCancel}>
          {t("BTN_CANCEL")}
        </Button>
      </DialogActions>
    </Dialog>
  </>
}